let counter = 0;
export const uniqueId = (str = '') => `${str}${++counter}`;
